import getUserAgent from './getUserAgent.js';

// Given an array of useragent regexes and a useragent,
// return the one that matches as both a string and regex match
export default function testUserAgent(list) {
  const ua = getUserAgent();
  for (const [name, regex] of list) {
    const pattern = new RegExp(...regex);
    const match = ua.match(pattern);
    if (match) return [name, match];
  }

  return [];
};